<template>
    <!-- Contenido que deseas incluir en el PDF -->
    <div class="container">
        <section class="hoja">
            <!-- seccion logo-->
            <div class="d-flex justify-content-end mb-4">
                <b-img :src="logo" style="width: 126px; height: 30px;"></b-img>
            </div>

            <!-- seccion -->
            <div class="py-1 px-3 text-white bg-subtitle">
                <span>Certificado de Finalización</span>
            </div>
            <div class="row text-start justify-content-start pt-1 mb-4">
                <div class="col-8 col-md-8">
                    <p class="text-h3 m-0 text-wrap text-break">Id: {{ data.Hash }}</p>
                    <p class="text-h3 m-0 text-wrap text-break">Asunto: {{ data.FileName }} Completado con ConfidenceID
                    </p>
                    <p class="text-h3 m-0 text-wrap text-break">Sobre de Origen: {{ data.Folder }}</p>
                    <p class="text-h3 m-0 text-wrap text-break">Páginas del Documento: {{ paginas_pdf }}</p>
                    <p class="text-h3 m-0 text-wrap text-break">Páginas del Certificado: {{ paginas_certificado }}</p>
                    <p class="text-h3 m-0 text-wrap text-break">Firma Guiada: {{ data.GuidedSignature }}</p>
                    <p class="text-h3 m-0 text-wrap text-break">Sello de Identificación del Sobre: Activado</p>
                    <p class="text-h3 m-0 text-wrap text-break">Zona Horaria: {{ data.TimeZone }}</p>
                </div>
                <div class="col-4 col-md-4">
                    <p class="text-h3 m-0 text-wrap text-break mb-3">Estado: {{ data.FileState }}</p>
                    <p class="text-h3 m-0 text-wrap text-break">Autor del Sobre: {{ creator.creatorName +" "+creator.creatorEmail}}</p>
                    <p class="text-h3 m-0 text-wrap text-break">Telefono: {{ creator.creatorPhone }}</p>
                </div>
            </div>
            <!-- seccion -->
            <div class="py-1 px-3 text-white bg-subtitle">
                <span>Seguimiento de Registro </span>
            </div>
            <div class="row text-start justify-content-start pt-1 mb-4">
                <div class="col-4 col-md-4 ">
                    <p class="text-h3 m-0 text-wrap text-break">Estado: Original {{ formatDate(data.FileCreated) }}</p>
                </div>
                <div class="col-4 col-md-4 ">
                    <p class="text-h3 m-0 text-wrap text-break">Titular: {{ creator.creatorName + " " + creator.creatorEmail }}
                    </p>
                </div>
                <div class="col-4 col-md-4 ">
                    <p class="text-h3 m-0 text-wrap text-break">Ubicación: ConfidenceID</p>
                </div>
            </div>

            <!-- seccion -->
            <div class="py-1 px-3 text-white bg-subtitle">
                <div class="row text-start justify-content-start ">
                    <div class="col-6 col-md-4 ">
                        <span>Eventos de Eventos del Sobre</span>
                    </div>
                    <div class="col-6 col-md-4 ">
                        <span>Estado</span>
                    </div>
                    <div class="col-6 col-md-4 ">
                        <span>Marca de tiempo</span>
                    </div>
                </div>
            </div>
            <div class="row text-start justify-content-start pt-1 mb-4">
                <div class="col-6 col-md-4 ">
                    <p class="text-h3 m-0 text-wrap text-break">Enviado</p>
                </div>
                <div class="col-6 col-md-4 ">
                    <p class="text-h3 m-0 text-wrap text-break">Con hash/cifrado</p>
                </div>
                <div class="col-6 col-md-4 ">
                    <p class="text-h3 m-0 text-wrap text-break">{{ formatDate(data.FileCreated) }}</p>
                </div>
            </div>
        </section>

        <!-- Sección de firmantes -->
        <section class="hoja" v-for=" (senderGroup,
            groupIndex) in chunks" :key="groupIndex">
            <!-- seccion logo-->
            <div class="d-flex justify-content-end mb-4">
                <b-img :src="logo" style="width: 126px; height: 30px;"></b-img>
            </div>
            <!-- Sección evidencias de firmantes -->
            <div class="py-1 px-3 text-white" style="background: #2e344a">
                <div class="row text-start justify-content-start">
                    <div class="col-4 col-md-4">
                        <span>Eventos de Firmantes</span>
                    </div>
                    <div class="col-4 col-md-4">
                        <span>Estado</span>
                    </div>
                    <div class="col-4 col-md-4">
                        <span>Fecha y Hora</span>
                    </div>
                </div>
            </div>
            <div class="row text-start justify-content-start pt-1 mt-4" v-for="(sender, index) in senderGroup" :key="index">
                <div class="col-4 col-md-4">
                    <div>
                        <p class="text-h3 m-0 text-wrap text-break">Nombre: {{ sender.Name }}</p>
                        <p class="text-h3 m-0 text-wrap text-break">Correo: {{ sender.SendTo }}</p>
                        <p class="text-h3 m-0 text-wrap text-break">Tipo de firma: {{ sender.SignatureOption }}
                        </p>
                        <p class="text-h3 m-0 text-wrap text-break">Autenticación de cuentas ({{
                            sender.SenderInfo.UserVerify ? "Activada" : "Ninguna"
                        }})</p>
                        <hr>
                        <p class="text-h3 m-0 text-wrap text-break">SO: {{ sender.SenderInfo.SO }}</p>
                        <p class="text-h3 m-0 text-wrap text-break">Browser: {{ sender.SenderInfo.Browser }}</p>
                        <p class="text-h3 m-0 text-wrap text-break">Ip: {{ sender.SenderInfo.IP }}</p>
                        <hr>
                    </div>
                </div>
                <div class="col-4 col-md-4">
                    <div>
                        <p class="text-h3 m-0 text-wrap text-break">{{ sender.State }}</p>
                    </div>
                </div>
                <div class="col-4 col-md-4">
                    <div>
                        <p class="text-h3 m-0 text-wrap text-break">Enviado: {{ formatDate(sender.SenderInfo.DateSent) }}</p>
                        <p class="text-h3 m-0 text-wrap text-break">Recepción: {{ formatDate(sender.SenderInfo.DateReception) }}</p>
                        <p class="text-h3 m-0 text-wrap text-break">Firmado: {{ formatDate(sender.SenderInfo.DateSign) }}</p>
                    </div>
                </div>
                <div class="col-12 col-md-12">
                    <div class="image-grid">
                        <img v-for="(img_evidence, imgIndex) in sender.SenderInfo.ClientImage" :key="imgIndex"
                            :src="img_evidence" :alt="`Evidencia ${index + 1}`">
                    </div>
                </div>
                <div class="col-12 col-md-12">
                    <hr role="separator" aria-orientation="horizontal" class="dropdown-divider"
                        v-if="index !== senderGroup.length - 1">
                </div>
            </div>
        </section>
    </div>
</template>
  
<script>
import axios from 'axios';
import { getPTP } from '../PDF.js/PDF';

export default {
    data: () => ({
        logo: undefined,
        paginas_certificado: 1,
        chunks: [],
        paginas_pdf: 1,
        creator: {}
    }),
    props: {
        data: {
            type: Object,
            required: false
        }
    },
    created() {
        this.getCreator();
    },
    mounted() {
        this.logo = require('@/assets/logoHorizontal.png');
        this.getDetailofPDF();
    },
    methods: {
        getCreator() {
            axios.get('/api/File/GetCreator/' + this.data.FileId).then(response => {
                this.creator = response.data.Result
            });
        },
        getDetailofPDF() {
            //console.log(this.data);
            this.getChunks(this.data.FileSenders, 2);
            this.getNumberOfPages(this.data.FileId);
        },
        async getNumberOfPages(FILEID) {
            getPTP(FILEID)
                .then(totalPages => {
                    this.paginas_pdf = totalPages;
                    //console.log('Total de páginas:', totalPages);
                })
                .catch(error => {
                    console.error('Error al obtener el total de páginas:', error);
                });
        },
        getChunks(arr, size) {

            for (let i = 0; i < arr.length; i += size) {
                this.chunks.push(arr.slice(i, i + size));
            }
            this.paginas_certificado += this.chunks.length;

        },
        //funcion para dar fromato a la fecha ejemplo Julio 21, 2021 a las 12:24 AM
        formatDate(data) {
            const meses = [
                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
                "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
            ];
            const fecha = new Date(data);
            const dia = fecha.getDate();
            const mes = meses[fecha.getMonth()];
            const año = fecha.getFullYear();
            const horas = fecha.getHours();
            const minutos = fecha.getMinutes();
            const ampm = horas >= 12 ? "PM" : "AM";
            const horas12 = horas % 12 || 12;

            const fechaFormateada = `${mes} ${dia}, ${año} a las ${horas12}:${minutos < 10 ? '0' : ''}${minutos} ${ampm}`;

            return fechaFormateada;
        }


    },
};
</script>
<style scoped>
.hoja {
    height: 984px;
}

.bg-subtitle {
    background: #2e344a !important;
}

div span {
    font-family: Helvetica, Arial !important;
    font-size: .8rem !important;
    font-weight: bold !important;
}

.text-h3 {
    font-family: Helvetica, Arial !important;
    font-size: .6rem !important;
    font-weight: 700 !important;
}

.image-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    grid-gap: 10px;
}

.image-grid img {
    width: 100%;
    height: auto;
}
</style>
  